export const qj =
{
  name: '趣教',
  mark: 'enteacher',
  press: '',
  business_id: 300000,
  app_id: 1294567623,
  ios_schema: 'qujiaoteacher',
  android_schema: 'com.zhl.enteacher.aphone',
  education_record_number: ''
}

